import { Btn } from "../../../../AbstractElements";
import { ButtonGroup, Col } from "reactstrap";
import { Left, Middle, Right } from "../../../../Constant";
import { CommonGroupButtonProp } from "../../../../Type/CommonComponant";

const CommonGroupButton = ({ data, buttonClass, size, outline }: CommonGroupButtonProp) => {
  return (
    <>
      {data.map((item, index) => (
        <Col xl="4" md="6" sm="12" key={index}>
          <ButtonGroup className={buttonClass}>
            <Btn outline={outline} size={size} color={item}>{Left}</Btn>
            <Btn outline={outline} size={size} color={item}>{Middle}</Btn>
            <Btn outline={outline} size={size} color={item}>{Right}</Btn>
          </ButtonGroup>
        </Col>
      ))}
    </>
  );
};

export default CommonGroupButton;
